var map = {
	"./AashiqueAhmedIqbal.png": 622,
	"./BusinessintheTimeofContagion.jpeg": 623,
	"./KarunaWielenga.png": 624,
	"./LakshmiSubramanian.png": 625,
	"./LouizaRodrigues.png": 626,
	"./MadMenofBombay.png": 627,
	"./MilanBalaban.png": 628,
	"./PowerPrivilegePosture.jpeg": 629,
	"./SaritaSundar.png": 630,
	"./Speaker1.png": 631,
	"./SusiePak.png": 632,
	"./TheGlobalBlueJeansTransformation.jpg": 633,
	"./TimberTradeTrajectory.jpeg": 634,
	"./TraceyPanek.png": 635,
	"./TypewriterTipTip.png": 636,
	"./WilliamMazzarella.png": 637,
	"./details-banner/BusinessInTheTimeOfContagion.png": 638,
	"./details-banner/MadMenOfBombay.png": 639,
	"./details-banner/PowerPrivilegeposture.png": 640,
	"./details-banner/TheGlobalBlueJeans.png": 641,
	"./details-banner/TimberTradeTrajectory.png": 642,
	"./details-banner/TypewriterTipTip.png": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;